import { render, staticRenderFns } from "./picture_cube.vue?vue&type=template&id=19de6522&scoped=true"
import script from "./picture_cube.vue?vue&type=script&lang=js"
export * from "./picture_cube.vue?vue&type=script&lang=js"
import style0 from "./picture_cube.vue?vue&type=style&index=0&id=19de6522&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19de6522",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19de6522')) {
      api.createRecord('19de6522', component.options)
    } else {
      api.reload('19de6522', component.options)
    }
    module.hot.accept("./picture_cube.vue?vue&type=template&id=19de6522&scoped=true", function () {
      api.rerender('19de6522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/picture_cube.vue"
export default component.exports